const TeamRoutes = [
    {
        path: "/team",
        meta: {
          requiresOwner: true,
        },
        name: "Team",
        component: () =>
          import(
            /* webpackChunkName: "TeamModule" */ "./views/Index.vue"
          ),
      },
    {
        path: "/team/invites/create",
        meta: {
          requiresOwner: true,
        },
        name: "CreateInvite",
        component: () =>
          import(
            /* webpackChunkName: "TeamModule" */ "./views/CreateInvite.vue"
          ),
      },
  ];
  
  export default TeamRoutes;
  